import logger from '@Map/logger/Logger';

/**
 * Debug logging for VectorTileLayer style API calls and `refresh()`.
 * Esri exposes `setStyleLayer` (not `setLayerStyle`).
 */
export function logVectorTileLayerStyleCall(
	method: 'loadStyle' | 'setStyleLayer' | 'refresh',
	vtl: { id?: string } | undefined,
	detail?: Record<string, unknown>,
): void {
	logger.debug(`VectorTileLayer ${method}`, {
		vtlId: vtl?.id,
		...detail,
	});
	// console.log(`VectorTileLayer ${method}`, {
	// 	vtlId: vtl?.id,
	// 	...detail,
	// });
}
